import 'whatwg-fetch'
import {API_URL} from '../constants/configValues'

const user = {
  updatePassword(token, systemID, newPassword) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/accounts/change-password`, {
        method: 'PUT',
        headers: headerJson,
        body: JSON.stringify(newPassword)
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({status: response.status, statusText: response.statusText})
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}
export default user



// WEBPACK FOOTER //
// ./src/api/user.js